"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitProps;
function splitProps(props, regExp) {
  var matchedProps = {};
  var unmatchedProps = {};

  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      if (key.match(regExp)) {
        matchedProps[key] = props[key];
      } else {
        unmatchedProps[key] = props[key];
      }
    }
  }

  return { matchedProps: matchedProps, unmatchedProps: unmatchedProps };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3V0aWxzL3NwbGl0UHJvcHMuanMiXSwibmFtZXMiOlsic3BsaXRQcm9wcyIsInByb3BzIiwicmVnRXhwIiwibWF0Y2hlZFByb3BzIiwidW5tYXRjaGVkUHJvcHMiLCJrZXkiLCJoYXNPd25Qcm9wZXJ0eSIsIm1hdGNoIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLFU7QUFBVCxTQUFTQSxVQUFULENBQXFCQyxLQUFyQixFQUE0QkMsTUFBNUIsRUFBb0M7QUFDakQsTUFBTUMsZUFBZSxFQUFyQjtBQUNBLE1BQU1DLGlCQUFpQixFQUF2Qjs7QUFFQSxPQUFLLElBQUlDLEdBQVQsSUFBZ0JKLEtBQWhCLEVBQXVCO0FBQ3JCLFFBQUlBLE1BQU1LLGNBQU4sQ0FBcUJELEdBQXJCLENBQUosRUFBK0I7QUFDN0IsVUFBSUEsSUFBSUUsS0FBSixDQUFVTCxNQUFWLENBQUosRUFBdUI7QUFDckJDLHFCQUFhRSxHQUFiLElBQW9CSixNQUFNSSxHQUFOLENBQXBCO0FBQ0QsT0FGRCxNQUVPO0FBQ0xELHVCQUFlQyxHQUFmLElBQXNCSixNQUFNSSxHQUFOLENBQXRCO0FBQ0Q7QUFDRjtBQUNGOztBQUVELFNBQU8sRUFBRUYsMEJBQUYsRUFBZ0JDLDhCQUFoQixFQUFQO0FBQ0QiLCJmaWxlIjoic3BsaXRQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNwbGl0UHJvcHMgKHByb3BzLCByZWdFeHApIHtcbiAgY29uc3QgbWF0Y2hlZFByb3BzID0ge31cbiAgY29uc3QgdW5tYXRjaGVkUHJvcHMgPSB7fVxuXG4gIGZvciAobGV0IGtleSBpbiBwcm9wcykge1xuICAgIGlmIChwcm9wcy5oYXNPd25Qcm9wZXJ0eShrZXkpKSB7XG4gICAgICBpZiAoa2V5Lm1hdGNoKHJlZ0V4cCkpIHtcbiAgICAgICAgbWF0Y2hlZFByb3BzW2tleV0gPSBwcm9wc1trZXldXG4gICAgICB9IGVsc2Uge1xuICAgICAgICB1bm1hdGNoZWRQcm9wc1trZXldID0gcHJvcHNba2V5XVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIHJldHVybiB7IG1hdGNoZWRQcm9wcywgdW5tYXRjaGVkUHJvcHMgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/utils/splitProps.js
// module id = 292
// module chunks = 0